/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Search_PlaceholderInputs */

const cs_ares_search_placeholder = /** @type {(inputs: Ares_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název firmy nebo IČO…`)
};

const en_ares_search_placeholder = /** @type {(inputs: Ares_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company name or IČO…`)
};

/**
* | output |
* | --- |
* | "Company name or IČO…" |
*
* @param {Ares_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_search_placeholder = /** @type {((inputs?: Ares_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_search_placeholder(inputs)
	return cs_ares_search_placeholder(inputs)
});